export const cognitoConfig = {
  UserPoolId: "ap-northeast-1_wWPruxvu0",
  ClientId: "6lv369imhln4tsvor6qa2hh2if",
};
